import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoonIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.moon-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("path", {
		className: "moon-icon-st0",
		d: "M10.7,2.1C8.1,4.1,6,7.3,6,12c0,4.6,1.9,7.8,4.5,9.9C5.7,21.2,2,17,2,12C2,6.9,5.8,2.7,10.7,2.1z M12,0 C5.4,0,0,5.4,0,12s5.4,12,12,12c1.9,0,3.9-0.3,5.4-1.2C13.9,22.2,8,19.5,8,12c0-7.6,6.4-10.3,9.4-10.8C15.6,0.5,13.9,0,12,0z M12,11 c1.4,0.4,2.6,1.6,3,3c0.4-1.4,1.6-2.6,3-3c-1.4-0.4-2.6-1.6-3-3C14.6,9.4,13.4,10.6,12,11z M20,11c1,0.3,1.7,1,2,2c0.3-1,1-1.7,2-2 c-1-0.3-1.7-1-2-2C21.7,10,21,10.7,20,11z M19,2c-0.4,1.4-1.6,2.6-3,3c1.4,0.4,2.6,1.6,3,3c0.4-1.4,1.6-2.6,3-3 C20.6,4.6,19.4,3.4,19,2z"
	})]
});
export default SvgMoonIcon;
